import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'Products';

const ProductsApi: any = baseApi(endpoint);

export default ProductsApi;